module.exports = __webpack_public_path__ + "img/services-background-03.49579a75.jpg";